import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiContenteditableService } from '@fi-shared/fi-contenteditable/fi-contenteditable.service';
import { ObjectTypes } from '@fi-shared/types';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';
import { ITaskEditName } from '@fi-shared/fi-task-shared/task-edit/task-edit';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-task-edit-task-name',
    templateUrl: './task-edit-task-name.component.html',
    styleUrls: ['./task-edit-task-name.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-edit-task-name' },
    providers: [{ provide: FiComponentsContainer, useExisting: TaskEditTaskNameComponent }],
    standalone: false,
})
export class TaskEditTaskNameComponent extends FiComponentsContainer {
    @Input() mediaBankFileReferences: IMediaBankFileReference[] = [];
    @Output() mediaBankFileReferencesChange = new EventEmitter<IMediaBankFileReference[]>();

    @Input() taskName: ITaskEditName;
    @Output() taskNameChange = new EventEmitter<ITaskEditName>();

    constructor(
        private contenteditableService: FiContenteditableService,
        private cdr: ChangeDetectorRef,
        private fiInsertMedia2Service: FiInsertMedia2Service,
    ) {
        super();
    }

    onMediaBankFileReferencesChange() {
        this.mediaBankFileReferencesChange.emit(this.mediaBankFileReferences);
    }

    openInsertMediaDialog(filesToUpload?: File[]) {
        this.fiInsertMedia2Service
            .openInsertMediaDialogWithFileSizes(ObjectTypes.Task, { filesToUpload: filesToUpload })
            .onYesButtonClick((result) => {
                this.mediaBankFileReferences = this.mediaBankFileReferences.concat(result.mediaBankFileReferences);
                this.cdr.markForCheck();
                this.onMediaBankFileReferencesChange();
            });
    }

    onFilesPasted($event: File[]): void {
        this.fiInsertMedia2Service
            .onFilePasted($event, ObjectTypes.Task)
            .then((mediaBankReferences: IMediaBankFileReference[]) => {
                this.mediaBankFileReferences = [...this.mediaBankFileReferences, ...mediaBankReferences];
                this.cdr.markForCheck();
                this.onMediaBankFileReferencesChange();
            });
    }

    onTaskNameChange(newTaskName: ITaskEditName) {
        this.taskName = newTaskName;
        this.taskNameChange.emit(this.taskName);
    }
}
